import {
  getBatchesForCourse,
  getAllBatches,
  saveBatch,
  deleteBatch
} from './api'
import { batchSlice } from './reducer'

const {
  resetBatches,
  updateFormValues,
  updateFormErrors,
  resetValues,
  setFormValues,
  resetError,
  setSelectedBatch
} = batchSlice.actions

export {
  getBatchesForCourse,
  resetBatches,
  getAllBatches,
  updateFormValues,
  updateFormErrors,
  saveBatch,
  resetValues,
  setFormValues,
  deleteBatch,
  resetError,
  setSelectedBatch
}
